const earthRadius = 3958.7614581;
const d2r = (d: number) => (d * Math.PI) / 180;
const haversineDistance = (
	fromLatitude: number,
	fromLongitude: number,
	toLatitude: number,
	toLongitude: number
) => {
	fromLatitude = d2r(fromLatitude);
	fromLongitude = d2r(fromLongitude);
	toLatitude = d2r(toLatitude);
	toLongitude = d2r(toLongitude);

	if (!(fromLatitude && fromLongitude) || !(toLatitude && toLongitude)) {
		return NaN;
	}

	return (
		2 *
		earthRadius *
		Math.asin(
			Math.sqrt(
				Math.pow(Math.sin((toLatitude - fromLatitude) / 2), 2) +
					Math.pow(Math.sin((fromLongitude - toLongitude) / 2), 2) *
						Math.cos(fromLatitude) *
						Math.cos(toLatitude)
			)
		)
	);
};

export { haversineDistance };
